import React from 'react';

export function SimpleTest() {
  return (
    <div style={{ 
      padding: '20px', 
      backgroundColor: '#f0f0f0', 
      minHeight: '100vh',
      fontFamily: 'Arial, sans-serif'
    }}>
      <h1 style={{ color: '#333', marginBottom: '20px' }}>Simple Test Page</h1>
      
      <div style={{ 
        backgroundColor: 'white', 
        padding: '20px', 
        borderRadius: '8px',
        marginBottom: '20px',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
      }}>
        <h2 style={{ color: '#666', marginBottom: '15px' }}>Basic Info</h2>
        <p><strong>User Agent:</strong> {navigator.userAgent}</p>
        <p><strong>Screen Width:</strong> {window.innerWidth}px</p>
        <p><strong>Screen Height:</strong> {window.innerHeight}px</p>
        <p><strong>Touch Support:</strong> {'ontouchstart' in window ? 'Yes' : 'No'}</p>
        <p><strong>Max Touch Points:</strong> {navigator.maxTouchPoints}</p>
        <p><strong>Timestamp:</strong> {new Date().toISOString()}</p>
      </div>

      <div style={{ 
        backgroundColor: 'white', 
        padding: '20px', 
        borderRadius: '8px',
        marginBottom: '20px',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
      }}>
        <h2 style={{ color: '#666', marginBottom: '15px' }}>Test Buttons</h2>
        <button 
          onClick={() => alert('Button clicked!')}
          style={{
            backgroundColor: '#3b82f6',
            color: 'white',
            border: 'none',
            padding: '10px 20px',
            borderRadius: '5px',
            marginRight: '10px',
            cursor: 'pointer'
          }}
        >
          Test Alert
        </button>
        
        <button 
          onClick={() => console.log('Console test')}
          style={{
            backgroundColor: '#10b981',
            color: 'white',
            border: 'none',
            padding: '10px 20px',
            borderRadius: '5px',
            marginRight: '10px',
            cursor: 'pointer'
          }}
        >
          Test Console
        </button>
      </div>

      <div style={{ 
        backgroundColor: 'white', 
        padding: '20px', 
        borderRadius: '8px',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
      }}>
        <h2 style={{ color: '#666', marginBottom: '15px' }}>Navigation</h2>
        <p>If you can see this page, the basic routing is working!</p>
        <p>Try navigating to:</p>
        <ul>
          <li><a href="/dashboard" style={{ color: '#3b82f6' }}>Dashboard</a></li>
          <li><a href="/events" style={{ color: '#3b82f6' }}>Events</a></li>
          <li><a href="/members" style={{ color: '#3b82f6' }}>Members</a></li>
          <li><a href="/mobile-test" style={{ color: '#3b82f6' }}>Mobile Test</a></li>
        </ul>
      </div>
    </div>
  );
}